import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import FrozenRemedyFilter from './FrozenRemedyFilter';
import FrozenRemedyTable from './FrozenRemedyTable';

export const frozenRemedyBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'analytics',
    url: '/analytics/revaluation/invoice'
  },

  {
    label: 'frozen_remedy',
    active: true
  }
];

const FrozenRemedy = () => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState(false);

  return (
    <div>
      <PageBreadcrumb items={frozenRemedyBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('frozen_remedy')}</h2>

        <FrozenRemedyFilter setTableData={setTableData} />
        <FrozenRemedyTable tableData={tableData} />
      </div>
    </div>
  );
};

export default FrozenRemedy;
